import AttachFileIcon from "@material-ui/icons/AttachFile";
import { useEffect, useRef, useState } from "react";
import FormulaIcon from "../../../images/formula.png";
import MathEditor from "../../MathEditor/MathEditor";
import { QuestionTypes } from "../../Questions/constant";

export default function QuestionInput({
  text,
  setText,
  placeholder,
  questionType,
  imageName,
  uploadFile,
  editor = false,
}) {
  const [openEditor, setOpenEditor] = useState(false);

  const editorRef = useRef(null);

  useEffect(() => {
    if (
      editor &&
      editorRef.current &&
      editorRef.current.innerHTML !== text
    ) {
      editorRef.current.innerHTML = text || "";
    }
  }, [text, editor]);

  const save = (value) => {
    setText(value);

    if (editor && editorRef.current) {
      editorRef.current.innerHTML = value;
    }

    setOpenEditor(false);
  };

  const disabled = questionType === "Choose Question Type";

  return (
    <>
      <div style={{ display: "flex", gap: "10px" }}>
        <div className="input-group mb-3 input-attach-group">
          {editor ? (
            <div
              ref={editorRef}
              className="form-control textQues question-input-editor-area"
              contentEditable={!disabled}
              suppressContentEditableWarning={true}
              data-placeholder={placeholder}
              onInput={(e) => setText(e.currentTarget.innerHTML)}
              style={{
                minHeight: "80px",
                overflowY: "auto",
              }}
            />
          ) : (
            <textarea
              className="form-control textQues"
              value={text}
              rows="2"
              onChange={(e) => setText(e.target.value)}
              placeholder={placeholder}
              aria-label={placeholder}
              aria-describedby="button-addon2"
              disabled={disabled}
            />
          )}

          {imageName ? (
            <>
              <label htmlFor={imageName}>
                <AttachFileIcon className="attach_icon" />
              </label>

              <input
                style={{ display: "none" }}
                type="file"
                accept={
                  questionType === QuestionTypes.DESCRIPTIVE
                    ? "image/*,audio/*,video/*"
                    : "image/*"
                }
                name={imageName}
                id={imageName}
                onChange={(e) =>
                  uploadFile(e, imageName, e.target.files[0])
                }
              />
            </>
          ) : null}
        </div>

        <img
          onClick={() => setOpenEditor(true)}
          src={FormulaIcon}
          alt="formula"
          style={{
            width: "25px",
            height: "fit-content",
            margin: "auto",
            cursor: "pointer",
          }}
        />
      </div>

      {openEditor ? (
        <MathEditor
          closeEditor={() => setOpenEditor(false)}
          initialHtml={text}
          saveEditor={save}
        />
      ) : null}
    </>
  );
}